import React, { FC } from 'react';
import { StyledLoadingContainer, StyledLoading } from './RCX.styled';

interface Props {
    visible: boolean;
}

export const Loading: FC<Props> = ({ visible }) => {
    return (
        <StyledLoadingContainer visible={visible}>
            <StyledLoading />
        </StyledLoadingContainer>
    );
};
